
import Vue, { PropType } from 'vue'

import { Activation, EditActivationStep } from '@/types/GCB2'

export default Vue.extend({
    name: 'EditActivationCopyButton',
    components: {},
    props: {
        activationsList: { type: Array as PropType<Activation[]> },
        step: { type: Object as PropType<EditActivationStep> },
        loading: { type: Boolean },
    },
    data: () => ({
        searchQuery: '',
        menuOpened: false,
    }),

    methods: {
        copyFromActivation(activation: Activation) {
            this.$emit('copy-from-activation', { step: this.step, activation })
            this.menuOpened = false
        },
    },
    computed: {
        filteredActivations(): Activation[] | undefined {
            if (!this.searchQuery) return this.activationsList
            try {
                const re = new RegExp(this.searchQuery, 'i')
                return this.activationsList?.filter((a: any) => a?.name && re.test(a.name))
            } catch (e) {
                return this.activationsList
            }
        },
    },
})
